export default {
  content: [
    {
      meta: {
        id: 'I_vL9QJFhI',
        order: 0,
        component: 'CustomerHubVideo',
      },
      styles: { customClasses: '' },
      content: {
        mode: 'user',
        tagline: '',
        variant: 'variant2',
        videoUrl: '',
        posterUrl: '',
        logoHeight: '70',
        includeLogo: true,
        backgroundImageUrl:
          'https://demo-system-next.s3.eu-north-1.amazonaws.com/oxygen/upload/editor/imranidz-QXT4/home-cmp-ZsApxvKAi',
        backgroundVideoUrl: '',
      },
      componentId: 'cmp-0',
    },
    {
      meta: {
        id: '_Glhy1Y_c6',
        order: 5,
        layout: '',
        _columns: 1,
        anchorId: 'use-case-review',
        component: 'Container',
        isFullWidth: true,
      },
      styles: {
        rowGap: '',
        columnGap: '',
        customClasses: 'BackgroundSecondary',
      },
      content: [
        [
          {
            meta: {
              id: 'KJzlWB7zee7',
              order: 8,
              component: 'Title',
            },
            content: {
              level: '1',
              title: 'Use Case & MVP Review',
              subtitle: '',
              alignment: 'center',
              textAlignment: 'center',
            },
            componentId: 'cmp-2-col_0-0',
          },
          {
            meta: {
              id: 'kS9EjFjkp3L',
              order: 8,
              layout: '',
              _columns: 4,
              component: 'Container',
              isFullWidth: false,
            },
            styles: {
              rowGap: '',
              columnGap: '',
              customClasses: 'Tiles',
            },
            content: [
              [
                {
                  meta: {
                    id: '1pZsEB9eTvw',
                    order: 8,
                    component: 'Card',
                  },
                  styles: {
                    customClasses: '',
                    backgroundColor: 'var(--backgroundColor)',
                  },
                  content: {
                    link: 'use-case-1',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/oxygen/upload/editor/bsoin-SF5T/home-cmp-1pZsEB9eTvw-image',
                    title: 'Use Case Review #1',
                    variant: 'vertical',
                    pretitle: 'May 31, 2023',
                    subtitle: '<p>Deep dive into use cases: Saver and Digital Advisor</p>',
                    alignment: 'left',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'Learn more',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                  componentId: 'cmp-1-col_0-1-col_0-0',
                },
              ],
              [
                {
                  meta: {
                    id: '8KwghS0uJdTMx3pPaeWlp',
                    component: 'Card',
                  },
                  styles: {
                    customClasses: '',
                    backgroundColor: 'var(--backgroundColor)',
                  },
                  content: {
                    link: 'use-case-2',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/oxygen/upload/editor/bsoin-SF5T/home-cmp-8KwghS0uJdTMx3pPaeWlp-image',
                    title: 'Use Case Review #2',
                    variant: 'vertical',
                    pretitle: 'June 15, 2023',
                    subtitle: '<p>Deep dive into use cases: Save Offer for Later and Automated Progression</p>',
                    alignment: 'left',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'Learn more',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                  componentId: 'cmp-1-col_0-1-col_1-0',
                },
              ],
              [
                {
                  meta: {
                    id: 'FTwzyP6_gZVXRCR-qMocP',
                    component: 'Card',
                  },
                  styles: {
                    customClasses: '',
                    backgroundColor: 'var(--backgroundColor)',
                  },
                  content: {
                    link: 'mvp',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/oxygen/upload/editor/bsoin-SF5T/home-cmp-FTwzyP6_gZVXRCR-qMocP-image',
                    title: 'MVP Discussions',
                    variant: 'vertical',
                    pretitle: 'August 10, 2023',
                    subtitle:
                      "<p>How to minimize time to value for SecurFinancial in its implementation of Adobe's Experience Platform.</p>",
                    alignment: 'left',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'Learn more',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                  componentId: 'cmp-1-col_0-1-col_2-0',
                },
              ],
              [
                {
                  meta: {
                    id: 'NxUSyjmtJ_7O8TXCiCip9',
                    component: 'Card',
                  },
                  styles: {
                    customClasses: '',
                    backgroundColor: 'var(--backgroundColor)',
                  },
                  content: {
                    link: 'enterprise-discussion',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/oxygen/upload/editor/bsoin-SF5T/home-cmp-NxUSyjmtJ_7O8TXCiCip9-image',
                    title: 'Enterprise Discussions',
                    variant: 'vertical',
                    pretitle: 'October 30, 2023',
                    subtitle:
                      '<p>High level overview of integrations, destinations and sources across the organization on an enterprise level.</p>',
                    alignment: 'left',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'Learn more',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                  componentId: 'cmp-1-col_0-1-col_3-0',
                },
              ],
            ],
            componentId: 'cmp-2-col_0-1',
          },
        ],
      ],
      componentId: 'cmp-1',
    },
    {
      meta: {
        id: 'VFg8QgVg45A',
        order: 7,
        layout: '',
        _columns: 1,
        anchorId: 'high-level-overview',
        component: 'Container',
        isFullWidth: true,
      },
      styles: {
        rowGap: '1rem',
        columnGap: '2rem',
        customClasses: 'BackgroundPrimary',
        paddingBottom: '4rem',
      },
      content: [
        [
          {
            meta: {
              id: 'HskODruWUfj',
              order: 9,
              component: 'Title',
            },
            content: {
              level: 1,
              title: 'High Level Overview',
              alignment: 'center',
              textAlignment: 'center',
            },
            componentId: 'cmp-2-col_0-0',
          },
          {
            meta: {
              id: 'KmI4ZfTQvQB',
              order: 9,
              layout: '',
              _columns: 4,
              component: 'Container',
              isFullWidth: false,
            },
            styles: {
              rowGap: '',
              columnGap: '',
              customClasses: 'Deliverables',
            },
            content: [
              [
                {
                  meta: {
                    id: '6IXg95RibDa',
                    order: 9,
                    component: 'Card',
                  },
                  styles: { customClasses: '' },
                  content: {
                    link: 'governance',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/deliverables-1.png',
                    title: 'Governance & Compliance',
                    variant: 'vertical',
                    pretitle: 'June 27, 2023',
                    subtitle: '<p>Overview of how the Adobe Experience Platform manages governance and compliance.</p>',
                    alignment: 'left',
                    buttonLink: '',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'Learn more',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                  componentId: 'cmp-2-col_0-1-col_0-0',
                },
              ],
              [
                {
                  meta: {
                    id: 'eZ01OIjcjj0',
                    order: 9,
                    component: 'Card',
                  },
                  styles: { customClasses: '' },
                  content: {
                    link: 'secuirty',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/deliverables-2.png',
                    title: 'Security',
                    variant: 'vertical',
                    pretitle: 'July 26, 2023',
                    subtitle:
                      "<p>Overview of Adobe resources available to answer security questions. Session to kick off the security review process and understand Vanguard's requirements. These are resources available in the meantime.</p>",
                    alignment: 'left',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'Learn more',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                  componentId: 'cmp-2-col_0-1-col_1-0',
                },
              ],
              [
                {
                  meta: {
                    id: 'VeEqGGd_e51',
                    order: 9,
                    component: 'Card',
                  },
                  styles: { customClasses: '' },
                  content: {
                    link: 'identity',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/deliverables-3.png',
                    title: 'Identity, Profile & Schemas',
                    variant: 'vertical',
                    pretitle: 'June 8, 2023',
                    subtitle:
                      '<p>Overview of how the Adobe Experience Platform manages identities, utilized our Experience Data Model (XDM) and brings together data to build a profile.</p>',
                    alignment: 'left',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'Learn more',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                  componentId: 'cmp-2-col_0-1-col_2-0',
                },
              ],
              [
                {
                  meta: {
                    id: 'RPL1D19WMfy',
                    order: 9,
                    component: 'Card',
                  },
                  styles: { customClasses: '' },
                  content: {
                    link: 'northstar-architecture',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/assets/luma/customer-hub/deliverables-4.png',
                    title: 'North Star Architecture',
                    variant: 'vertical',
                    pretitle: 'August 18, 2023',
                    subtitle:
                      '<p>Deep dive into current state architecture and drive towards future-state North Star Architecture. Scroll to find recordings, and current North Star Architecture Diagrams.</p>',
                    alignment: 'left',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'Learn more',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                  componentId: 'cmp-2-col_0-1-col_3-0',
                },
              ],
            ],
          },
        ],
      ],
      componentId: 'cmp-2',
    },
    {
      meta: {
        id: 'vh6LM1y4zmy2p8siaymIT',
        layout: '',
        _columns: 1,
        anchorId: 'solution-overviews',
        component: 'Container',
        isFullWidth: true,
      },
      styles: {
        rowGap: '',
        columnGap: '',
        customClasses: 'BackgroundSecondary',
        backgroundColor: 'black',
      },
      content: [
        [
          {
            meta: { id: 'AOYhdeQAnbjY-yQn2Xmx6', component: 'Title' },
            styles: { color: 'white' },
            content: {
              level: '1',
              title: 'Solution Overviews',
              subtitle: '',
              alignment: 'center',
              textAlignment: 'center',
            },
            componentId: 'cmp-3-col_0-0',
          },
          {
            meta: {
              id: 'gXfpFHQ-s_E9Z7LQiZSAn',
              layout: '',
              _columns: 4,
              component: 'Container',
              isFullWidth: false,
            },
            styles: {
              rowGap: '',
              columnGap: '',
              customClasses: 'Tiles',
            },
            content: [
              [
                {
                  meta: {
                    id: 'MP5_5zT9gb3R6_kOrJiVf',
                    component: 'Card',
                  },
                  styles: {
                    customClasses: '',
                    backgroundColor: 'var(--backgroundColor)',
                  },
                  content: {
                    link: 'rtcdp',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/oxygen/upload/editor/bsoin-SF5T/home-cmp-MP5_5zT9gb3R6_kOrJiVf-image',
                    title: 'RTCDP',
                    variant: 'vertical',
                    pretitle: 'June 15, 2023',
                    subtitle:
                      '<p>Demo of RTCDP. Focused on profiles, audiences, governance policies, sources and destinations.</p>',
                    alignment: 'left',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'Learn more',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                  componentId: 'cmp-3-col_0-1-col_0-0',
                },
              ],
              [
                {
                  meta: {
                    id: 'AkUusjn0BARS3rbxRGp_c',
                    component: 'Card',
                  },
                  styles: {
                    customClasses: '',
                    backgroundColor: 'var(--backgroundColor)',
                  },
                  content: {
                    link: 'cja',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/oxygen/upload/editor/bsoin-SF5T/home-cmp-AkUusjn0BARS3rbxRGp_c-image',
                    title: 'Customer Journey Analytics',
                    variant: 'vertical',
                    pretitle: 'August 31, 2023',
                    subtitle:
                      '<p>Overview of how <strong>Customer Journey Analytics (CJA)</strong> can provide omni-channel analysis for your organization.</p>',
                    alignment: 'left',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'Learn more',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                  componentId: 'cmp-3-col_0-1-col_1-0',
                },
              ],
              [
                {
                  meta: {
                    id: 'Vit_H1YZWnWKupluJ5SLk',
                    component: 'Card',
                  },
                  styles: {
                    customClasses: '',
                    backgroundColor: 'var(--backgroundColor)',
                  },
                  content: {
                    link: 'ajo',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/oxygen/upload/editor/bsoin-SF5T/home-cmp-Vit_H1YZWnWKupluJ5SLk-image',
                    title: 'Adobe Journey Optimizer',
                    variant: 'vertical',
                    pretitle: 'July 31, 2023',
                    subtitle:
                      "<p>A deep dive into AJO, an application service that sits on top of AEP. AJO's approach to journeys, batch campaigns, and a high-level approach to offers decisioning.</p>",
                    alignment: 'left',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'Learn more',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                  componentId: 'cmp-3-col_0-1-col_2-0',
                },
              ],
              [
                {
                  meta: {
                    id: 'finZH1cVdCdf7BwFUDny5',
                    component: 'Card',
                  },
                  styles: {
                    customClasses: '',
                    backgroundColor: 'var(--backgroundColor)',
                  },
                  content: {
                    link: 'od',
                    image:
                      'https://demo-system-next.s3.eu-north-1.amazonaws.com/oxygen/upload/editor/bsoin-SF5T/home-cmp-finZH1cVdCdf7BwFUDny5-image',
                    title: 'Offer Decisioning',
                    variant: 'vertical',
                    pretitle: 'August 3, 2023',
                    subtitle:
                      "<p>Offer Decisioning is a part of AJO. This deep dive focuses on creating offers, managing content, and using ranking formulas or AI/ML. Discussion on how AJO fits into PACE's architecture and requirements.</p>",
                    alignment: 'left',
                    selectable: false,
                    titleLevel: 4,
                    buttonLabel: 'Learn more',
                    buttonVariant: 'link',
                    verticalAlignment: 'top',
                  },
                  componentId: 'cmp-3-col_0-1-col_3-0',
                },
              ],
            ],
            componentId: 'cmp-2-col_0-1',
          },
        ],
      ],
      componentId: 'cmp-3',
    },
    {
      meta: {
        id: '1MnK8DleT0a',
        order: 8,
        layout: '',
        _columns: 1,
        component: 'Container',
        isFullWidth: true,
      },
      styles: {
        rowGap: '1rem',
        columnGap: '2rem',
        customClasses: '',
        paddingBottom: '4rem',
      },
      content: [
        [
          {
            meta: {
              id: 'DszNXqQw4V6',
              order: 11,
              component: 'Title',
            },
            content: {
              level: 1,
              title: 'Your Adobe Team',
              pretitle: '',
              subtitle: "<p>We're here to help</p>",
              alignment: 'center',
              textAlignment: 'center',
            },
            componentId: 'cmp-3-col_0-0',
          },
          {
            meta: {
              id: 'TrB1Va1GCka',
              order: 12,
              component: 'GridContainer',
              isFullWidth: false,
            },
            styles: {
              rowGap: '',
              columnGap: '',
              customClasses: 'AccountTeam',
              gridTemplateRows: '',
              gridTemplateColumns: '',
            },
            content: [
              {
                meta: {
                  id: 'ligUNHkYT6N',
                  order: 11,
                  component: 'Card',
                },
                content: {
                  image:
                    'https://demo-system-next.s3.eu-north-1.amazonaws.com/oxygen/upload/editor/bsoin-SF5T/home-cmp-ligUNHkYT6N-image',
                  title: 'Clare Naito',
                  variant: 'vertical',
                  subtitle: '<p>Account Director</p>',
                  buttonLink: 'mailto:imranidz@adobe.com',
                  selectable: false,
                  titleLevel: 5,
                  buttonLabel: 'cnaito@adobe.com',
                  buttonVariant: 'secondary',
                },
                componentId: 'cmp-4-col_0-1-0',
              },
              {
                meta: {
                  id: 'MRQh3zjkKFF',
                  order: 11,
                  component: 'Card',
                },
                content: {
                  image:
                    'https://demo-system-next.s3.eu-north-1.amazonaws.com/oxygen/upload/editor/bsoin-SF5T/home-cmp-MRQh3zjkKFF-image',
                  title: 'Edward Fisher',
                  variant: 'vertical',
                  pretitle: '',
                  subtitle: '<p>Account Specialist</p>',
                  buttonLink: 'mailto:edfisher@adobe.com',
                  selectable: false,
                  titleLevel: 5,
                  buttonLabel: 'edfisher@adobe.com',
                  buttonVariant: 'secondary',
                },
                componentId: 'cmp-4-col_0-1-1',
              },
              {
                meta: {
                  id: '2CZkpThXWR6',
                  order: 11,
                  component: 'Card',
                },
                content: {
                  image:
                    'https://demo-system-next.s3.eu-north-1.amazonaws.com/oxygen/upload/editor/bsoin-SF5T/home-cmp-2CZkpThXWR6-image',
                  title: 'Claudia Vanderbilt',
                  variant: 'vertical',
                  subtitle: '<p>Solutions Consultant</p>',
                  buttonLink: 'mailto:imranidz@adobe.com',
                  selectable: false,
                  titleLevel: 5,
                  buttonLabel: 'cvandy@adobe.com',
                  buttonVariant: 'secondary',
                },
                componentId: 'cmp-4-col_0-1-2',
              },
              {
                meta: {
                  id: 'BsL69kFaFXA35A4HqdZhk',
                  component: 'Card',
                },
                content: {
                  image:
                    'https://demo-system-next.s3.eu-north-1.amazonaws.com/oxygen/upload/editor/bsoin-SF5T/home-cmp-BsL69kFaFXA35A4HqdZhk-image',
                  title: 'Dave Debenham',
                  variant: 'vertical',
                  subtitle: '<p>Enterprise Architect</p>',
                  buttonLink: 'mailto:ea@adobe.com',
                  selectable: false,
                  titleLevel: 5,
                  buttonLabel: 'daved@adobe.com',
                  buttonVariant: 'secondary',
                },
                componentId: 'cmp-4-col_0-1-3',
              },
            ],
          },
        ],
      ],
      componentId: 'cmp-3',
    },
    {
      meta: {
        id: 'VLoEnukRlSS',
        order: 9,
        layout: 'wrap',
        component: 'List',
        isFullWidth: false,
        itemAlignment: 'left',
      },
      styles: {
        paddingTop: '3rem',
        customClasses: 'BackgroundPrimary footer',
      },
      content: [
        {
          meta: {
            id: '7Lu8fu9QliJ',
            order: 11,
            component: 'CustomerHubLogo',
          },
          content: {
            mode: 'user',
            logoHeight: '70',
            showScrollUpButton: true,
          },
        },
      ],
      componentId: 'cmp-4',
    },
  ],
}
